import { datePickerStyle } from '@bingads-webui-campaign-react/common-styles';
import { ComponentSettings } from '@bingads-webui-theme-2018/theme-fluent';

import { bulkEditStyle } from './bulk-edit-style';
import { upgradedUrlOverrideStyle } from './upgraded-url-override-style';
import { getAutomatedRulesStyles } from './automated-rules-style';
import { getBulkEditOverrideStyle } from './bulk-edit-override-style';
import { getInlineDownloadStyle } from './inline-download-style';
import { pasteStyle } from './paste-style';

const {
  columnChooserStyle,
  getColumnChooserOverrideStyle,
  filterEditorStyle,
  getFilterEditorOverrideStyle,
  getTopGridPanelCommonStyle,
} = ComponentSettings;

export const getTopGridPanelDefaultStyles = (_, {
  palette = {},
  semanticColors = {},
  spacing = {},
}) => ({
  // Don't inject to global
  topGridPanelDefaultStyles: Object.assign(
    {},
    {
      // make sure we don't occupy any vertical space when panel is hidden
      padding: '0px',
      margin: '0px',
      minWidth: '1000px',
      maxWidth: '1500px',
      position: 'relative',
      zIndex: 1,

      '&:focus': {
        outline: 'none',
      },
      // Styles for panel itself
      ...getTopGridPanelCommonStyle({ palette }),

      '& .warn.warn-info.form-group': {
        padding: 8,
        background: '#FFF4CE',
        marginBottom: '5px',
        fontSize: '12px',
        width: '450px',

        '& .warn-image': {
          color: '#D83B01',
          fontSize: '16px !important',
          float: 'left',
          paddingRight: '5px',
        },
      },
    },
    // Styles for each of the panel contents
    bulkEditStyle({ palette }),
    getBulkEditOverrideStyle({ palette }),
    upgradedUrlOverrideStyle,
    getAutomatedRulesStyles({ palette, semanticColors, spacing }),
    columnChooserStyle,
    getColumnChooserOverrideStyle(palette),
    filterEditorStyle,
    getFilterEditorOverrideStyle(palette),
    getInlineDownloadStyle({ palette }),
    pasteStyle
  ),
  '@global': Object.assign(
    {},
    datePickerStyle({ palette })
  ),
});

